import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest } from "../services/index";

const API_URL = "/api/overtime"; // Matches your backend route in server.ts

// Fetch Overtime Records
export const fetchOvertime = createAsyncThunk("overtime/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  console.log("API Response:", response.data);
  return response.data;
});

// Add Overtime Record
export const addOvertime = createAsyncThunk("overtime/add", async (overtimeData) => {
  const response = await hrmsPostRequest(API_URL, overtimeData);
  return response.data;
});

// Approve or Reject Overtime
export const updateOvertimeStatus = createAsyncThunk(
  "overtime/updateStatus",
  async ({ id, status, approvedBy }) => {
    const endpoint = status === "Approved" ? `${API_URL}/approve` : `${API_URL}/reject`;
    const response = await hrmsUpdateRequest(endpoint, { id, approvedBy });
    return response.data;
  }
);

const overtimeSlice = createSlice({
  name: "overtime",
  initialState: {
    overtimeRecords: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOvertime.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOvertime.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.overtimeRecords = action.payload;
      })
      .addCase(fetchOvertime.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addOvertime.fulfilled, (state, action) => {
        state.overtimeRecords.push(action.payload);
      })
      .addCase(updateOvertimeStatus.fulfilled, (state, action) => {
        const index = state.overtimeRecords.findIndex((o) => o.id === action.payload.id);
        if (index !== -1) {
          state.overtimeRecords[index] = action.payload;
        }
      });
  },
});

export default overtimeSlice.reducer;